import WRAP from 'WRAP-JS'
import { MAP_ID_TILEMAP } from "../../../store/MapContentsState";
class TileMap {
  static NAME = MAP_ID_TILEMAP;
  gsiMapDh;
  gsiMapLayerConfig;
  gsiMapLayer;
  hillshadeMapDh;
  hillshadeMapLayerConfig;
  hillshadeMapLayer;
  simpleMapDh;
  simpleMapLayerConfig;
  simpleMapLayer;
  visible = false;
  color;
  whitePalette = [];
  blackPalette = [];

  constructor(color) {
    this.color = color;
    this.gsiMapLayer = new WRAP.Geo.Layer('TileMap');
    this.gsiMapLayer.setVisible(false);
    this.gsiMapLayer.disableInteraction(true);
    this.hillshadeMapLayer = new WRAP.Geo.Layer('HillshadeTileMap');
    this.hillshadeMapLayer.setVisible(false);
    this.hillshadeMapLayer.disableInteraction(true);
    this.simpleMapLayer = new WRAP.Geo.Layer('SimpleMap');
    this.simpleMapLayer.setVisible(false);
    this.simpleMapLayer.disableInteraction(true);
  }

  initialize() {
    this.initData();
    this.initLayer()
  }

  initData() {
    this.gsiMapDh = new WRAP.Data({
      "Controller": {
        "Name": "EXPO_Tile"
      },
      "Source": {
        "data": {
          "Type": "TMS",
          "Name": "MAP_GSI_MER",
          "__url": "%expo_map_url%/png_tile/GSI_PALE_MERCTR/%z%_%y%_%x%.png",
          "___url": "%expo_map_url%/png_tile/GSI_STD_MERCTR/%z%_%y%_%x%.png",
          "url": "https://cyberjapandata.gsi.go.jp/xyz/pale/%z%/%x%/%y%.png",
          "_____url": "https://cyberjapandata.gsi.go.jp/xyz/std/%z%/%x%/%y%.png",

          "cache": true,
          "download_max": 32,
          "Grid": {
            "MinZoom": 1,
            "MaxZoom": 18,
            "Complement" : true,
            "YCoordinate": -1,
            "BoundingBox": {
              "West": -180,
              "South": -90,
              "East": 180,
              "North": 90
            }
          }
        }
      }
    });

    this.hillshadeMapDh = new WRAP.Data({
      "Controller": {
        "Name": "EXPO_Tile"
      },
      "Source": {
        "data": {
          "Type": "TMS",
          "Name": "MAP_HILLSHADE_MER",
          "url": "https://cyberjapandata.gsi.go.jp/xyz/hillshademap/%z%/%x%/%y%.png",
          "cache": true,
          "download_max": 32,
          "Grid": {
            "MinZoom": 2,
            "MaxZoom": 16,
            "Complement" : true,
            "YCoordinate": -1,
            "BoundingBox": {
              "West": 122,
              "South": 20,
              "East": 154,
              "North": 46
            }
          }
        }
      }
    });

    this.simpleMapDh = new WRAP.Data({
      "Controller": {
        "Name": "EXPO_Tile"
      },
      "Source": {
        "data": {
          "Type": "TMS",
          "Name": "MAP_ReliefAntialias_MER",
          "url": "%expo_map_url%/png_tile/NGA_VMAP_MERCTR/%z%_%y%_%x%.png",
          "cache": true,
          "download_max": 32,
          "Grid": {
            "MinZoom": 0,
            "MaxZoom": 14,
            "Complement" : true,
            "YCoordinate": -1,
            "BoundingBox": {
              "West": -180,
              "South": -90,
              "East": 180,
              "North": 90
            }
          }
        }
      }
    });
  }

  initLayer() {
    this.gsiMapLayerConfig = {
      "Name": "TileMap",
      "Renderer": "Image",
      "Attributes": {
        "style": {
          "default": {
            "type": "grayscale_palette",
            "min_filter": "NEAREST",
          }
        }
      }
    };

    this.hillshadeMapLayerConfig = {
      "Name": "TileMap",
      "Renderer": "Image",
      "Attributes": {
        "style": {
          "default": {
            "type": "grayscale_palette",
            "min_filter": "NEAREST",
          }
        }
      }
    };

    this.simpleMapLayerConfig = {
      "Name": "TileMap",
      "Renderer": "Image",
      "Attributes": {
        "style": {
          "default": {
            "type": "grayscale_palette",
            "mag_filter": "NEAREST",
            "min_filter": "NEAREST",
          }
        }
      }
    };
    this.gsiMapLayer.configure(this.gsiMapDh, this.gsiMapLayerConfig);
    this.gsiMapLayer.set({});

    this.hillshadeMapLayer.configure(this.hillshadeMapDh, this.hillshadeMapLayerConfig);
    this.hillshadeMapLayer.set({});

    this.whitePalette.push([255, 255, 255, 255]); //sea
    this.blackPalette.push([0, 0, 0, 255]);//sea
    for (let i = 0; i < 254; i += 1) {
      this.whitePalette.push([0, 0, 0, 0]);
      this.blackPalette.push([0, 0, 0, 0]);
    }
    this.whitePalette.push([240, 239, 232, 255]);//land
    this.blackPalette.push([34, 34, 34, 255]);//land

    this.simpleMapLayerConfig.Attributes.style.default.palette = this.color === 'white'? this.whitePalette : this.blackPalette;
    this.simpleMapLayer.configure(this.simpleMapDh, this.simpleMapLayerConfig);
    this.simpleMapLayer.set({});
  }

  async drawLayer(visible) {
    if (!this.gsiMapDh) {
      this.initialize();
    }
    this.setVisible(visible);
  }
  getLayer() {
    return [this.gsiMapLayer, this.simpleMapLayer, this.hillshadeMapLayer];
  }

  setVisible(visible) {
    this.visible = visible;
    if (this.color === 'gsi') {
      if (visible) {
        this.gsiMapLayer.show();
      } else {
        this.gsiMapLayer.hide();
      }
    } else if (this.color === 'white') {
      if (visible) {
        this.simpleMapLayer.show();
        this.hillshadeMapLayer.show();
        // if (this.isJapanArea()) {
        //   this.simpleMapLayer.hide();
        //   this.hillshadeMapLayer.show();
        // } else {
        //   this.simpleMapLayer.show();
        //   this.hillshadeMapLayer.hide();
        // }
      } else {
        this.simpleMapLayer.hide();
        this.hillshadeMapLayer.hide();
      }
    } else {
      if (visible) {
        this.simpleMapLayer.show();
      } else {
        this.simpleMapLayer.hide();
      }
    }
  }

  applyMapColor(color) {
    if ((this.color === 'gsi' && color !== 'gsi') || (this.color !== 'gsi' && color === 'gsi')) {
      const visible = this.visible;
      this.setVisible(false);
      this.color = color;
      this.setVisible(visible);
    } else if ((this.color === 'white' && color !== 'white') || (this.color !== 'white' && color === 'white')) {
      const visible = this.visible;
      this.setVisible(false);
      this.color = color;
      this.setVisible(visible);
    } else {
      this.color = color;
    }

    if (this.color === 'gsi') {
      this.gsiMapLayer.invalidate();
    } else {
      this.simpleMapLayerConfig.Attributes.style.default.palette = this.color === 'white'? this.whitePalette : this.blackPalette;
      this.simpleMapLayer.invalidate();
      if (this.color === 'white') {
        this.hillshadeMapLayer.invalidate();
      }
    }
  }

  // updateBounds() {
  //   if (this.color === 'white') {
  //     if (this.isJapanArea()) {
  //       this.hillshadeMapLayer.show();
  //       this.simpleMapLayer.hide();
  //     } else {
  //       this.hillshadeMapLayer.hide();
  //       this.simpleMapLayer.show();
  //     }
  //   }
  // }

  // isJapanArea() {
  //   const current = WRAP.Geo.currentView();
  //   const bounds = current.bounds;
  //   console.log(`east=${bounds.east} north=${bounds.north} south=${bounds.south} west=${bounds.west}`);
  //   return bounds.east <= 154 && bounds.north <= 46 && bounds.south >= 20 && bounds.west >= 122;
  // }
}

export default TileMap;
